import { Box } from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const TimeCell = ({ params, rows, setRows, selectedDay }) => {
	const { t } = useTranslation();
	const [time, setTime] = useState(params.value);

	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				width: "100%",
				height: "100%",
			}}
		>
			<TimePicker
				label={t(
					"timekeeper.schedule.table.modals.add.table.columns.hours"
				)}
				value={time}
				onChange={(nv) => {
					const datetime = selectedDay.clone().set({
						hour: nv.hour(),
						minute: nv.minute(),
						second: nv.second(),
					});

					setTime(datetime);
					setRows(
						rows.map((row) =>
							row.id === params.row.id
								? { ...row, [params.field]: datetime }
								: row
						)
					);
				}}
				ampm={false}
				fullWidth
			/>
		</Box>
	);
};

export { TimeCell };
